
export const SET_ID_TOKEN = 'SET_ID_TOKEN'
export function setIdToken(token) {
    return {
        type: SET_ID_TOKEN,
        payload: token,
    }
}

export const RESET_ID_TOKEN = 'RESET_ID_TOKEN'
export function resetIdToken() {
    return {
        type: RESET_ID_TOKEN,
        payload: null,
    }
}



// WEBPACK FOOTER //
// ./src/actions/authentication.js